/**
 * The portal's one underline. Every link underline is 1px in `currentColor`,
 * so it always matches its text: off-black on a normal link, red or green on a
 * coloured toast or error link.
 *
 *   - `UNDERLINE_SLIDE_IN` — hidden at rest, slides in on hover (table links,
 *     breadcrumbs). Scales a pseudo-element, so hovering never shifts layout.
 *     Needs a positioned element; it carries `relative` itself.
 *   - `UNDERLINE_SLIDE_IN_GROUP` — the same, triggered by a `group/underline`
 *     parent (a whole row or button is the hover target, not the text).
 *   - `UNDERLINE_STATIC` — always shown (inline links in toasts, bars, notices).
 *
 * Complete literals rather than composed strings so Tailwind's scanner sees
 * every class.
 */
export const UNDERLINE_SLIDE_IN =
  "relative after:absolute after:left-0 after:bottom-0 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-current after:duration-200 after:ease-out motion-safe:after:transition-transform hover:after:scale-x-100"

export const UNDERLINE_SLIDE_IN_GROUP =
  "relative after:absolute after:left-0 after:bottom-0 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-current after:duration-200 after:ease-out motion-safe:after:transition-transform group-hover/underline:after:scale-x-100"

export const UNDERLINE_STATIC = "underline decoration-1 underline-offset-[3px]"
